import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=072209b2&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072209b2')) {
      api.createRecord('072209b2', component.options)
    } else {
      api.reload('072209b2', component.options)
    }
    module.hot.accept("./logout.vue?vue&type=template&id=072209b2&", function () {
      api.rerender('072209b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/logout.vue"
export default component.exports